import { useCallback } from 'react';
import { useStore } from 'src/contexts/StoreContext';
import { getSelectedLookupTitle } from 'src/screen/picture_view/utils/getSelectedLookupTitle';
import { ILookupModel } from 'src/store/_models/lookup';

export const useProductLogic = product => {
  const { i18n } = useStore();

  const getProductLookupTitle = useCallback(
    (lookup: ILookupModel) => {
      return (product && getSelectedLookupTitle(product, lookup.code, { i18n })) || '';
    },
    [product],
  );

  return { getProductLookupTitle };
};
